export default __webpack_public_path__ + "static/media/trailblazersLogo.3c10f767.png";